import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { IClientCompanyDropdown, ICompanyMastDropdown } from "../../models/IDropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { ca } from "date-fns/locale";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { IQualityControleList } from "./Table";
import { call_Quality, confidence_Level, voice_Pitch } from "./dropdowns";

interface IProps {
    singleData: IQualityControleList,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export interface IQualtiyControle {
    id?: number,
    call_Type?: string,
    initiator_Type?: string, // PV, SV, Consultant,
    initiator_Entity?: any | null, // PV Company Name, SV Company Name, Consultant Company Name
    point_Of_Contact?: string, // PV Contact Person, SV Contact Person, Consultant Name
    receiver_Type?: string, // Phone, Email, WhatsApp
    receiver_Entity?: any | null, // Phone, Email, WhatsApp
    receiver_Name?: string, // Phone, Email, WhatsApp
    subject?: string,
    call_Duration?: number, // in minutes
    confidence_Level?: string, // High, Medium, Low
    voice_Pitch?: string, // High, Medium, Low
    points_Discussed?: string,
    call_Quality?: string, // Excellent, Good, Average, Poor
    call_Recording_Path?: string, // URL of the recording Path
}

const schema = yup.object({
    call_Type: yup.string().required("Call Type is required"),
    initiator_Type: yup.string().required("Initiator Type is required"),
    // initiator_Entity: yup.string().when('initiator_Type', val => {
    //     return (val === "Consultant") ?
    //         yup.string().nullable() : ((val === "InHouse User") ? yup.string().required("Initiator Entity is required") : yup.object().required("Initiator Entity is required"))
    // }),
    point_Of_Contact: yup.string().required("Point of Contact is required"),
    receiver_Type: yup.string().required("Receiver Type is required"),
    // receiver_Entity: yup.string().when('receiver_Type', val => {
    //     return (val === "Consultant") ?
    //         yup.string().nullable() : ((val === "InHouse User") ? yup.string().required("Receiver Entity is required") : yup.object().required("Receiver Entity is required"))
    // }),
    receiver_Name: yup.string().required("Receiver Name is required"),
    subject: yup.string().required("Subject is required"),
    call_Duration: yup.number().required("Call Duration is required"),
    confidence_Level: yup.string().required("Confidence Level is required"),
    voice_Pitch: yup.string().required("Voice & Pitch is required"),
    call_Quality: yup.string().required("Call Quality is required"),
});

export const Form = (props: IProps) => {
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>([]);
    const [subvendorCompanies, setSubvendorCompanies] = useState<Array<IClientCompanyDropdown>>([]);
    const [company, setCompany] = useState<Array<ICompanyMastDropdown>>([]);
    const [initiatorEntity, setInitiatorEntity] = useState<string>("");
    const [receiverEntity, setReceiverEntity] = useState<string>("");
    const [values, setValues] = useState<string>("");
    const [audioFile, setAudioFile] = useState<File | null | any>(null);
    const [loading, setLoading] = useState(false);


    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<IQualtiyControle>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
            if (props.singleData.receiver_Type === "Prime Vendor") {
                setValue("receiver_Entity", data.filter(f => f.vendor_Company_Name === props.singleData.receiver_Entity)[0]);
            }
            if (props.singleData.initiator_Type === "Prime Vendor") {
                setValue("initiator_Entity", data.filter(f => f.vendor_Company_Name === props.singleData.initiator_Entity)[0]);
            }
        }
    }
    const loadSubvendorCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setSubvendorCompanies(data);
            console.log(data);
            if (props.singleData.receiver_Type === "Sub Vendor") {
                console.log(data.filter(f => f.vendor_Company_Name === props.singleData.receiver_Entity)[0]);
                setValue("receiver_Entity", data.filter(f => f.vendor_Company_Name === props.singleData.receiver_Entity)[0]);
            }
            if (props.singleData.initiator_Type === "Sub Vendor") {
                console.log(data.filter(f => f.vendor_Company_Name === props.singleData.initiator_Entity)[0]);
                setValue("initiator_Entity", data.filter(f => f.vendor_Company_Name === props.singleData.initiator_Entity)[0]);
            }
        }
    }

    const completeMethodEntityClient = (event: { query: string }) => {
        console.log("1", event);
        loadClientCompanies(event.query);
    }
    const completeMethodEntitySubvendor = (event: { query: string }) => {
        console.log("2", event);
        loadSubvendorCompanies(event.query);
    }

    const loadCompany = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompany(data);
        }
    }

    const onHide = () => {
        setAudioFile(null);
        props.hideDialog();
        reset({});
    };

    const saveToDB = async (bodys: IQualtiyControle) => {
        let newData: IQualtiyControle = bodys;
        if (props.singleData.id) {
            newData.id = props.singleData.id;
        }

        if (audioFile === null) {
            setLoading(true);
            const formData = new FormData();
            // formData.append('audio', audioFile);
            formData.append('bodyData', JSON.stringify(newData));
            const params = {
                method: (newData.id !== null && newData.id !== undefined && newData.id > 0) ? "PUT" : "POST",
                headers: {
                    'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                },
                body: formData
            };
            const response = await fetch(`${baseUrl}QualityControle`, params);

            //const response = await Fetch("QualityControle", (body.id !== null && body.id !== undefined && body.id > 0) ? "PUT" : "POST", body, null, props.toast);
            if (response.ok) {
                props.toast.current.show({ severity: 'success', detail: "Saved Successfully", life: 3000 });
                props.setReload(!props.reload);
                onHide();
            }
            setLoading(false);
        } else {
            setLoading(true);
            const formData = new FormData();
            formData.append('audio', audioFile);
            formData.append('bodyData', JSON.stringify(newData));
            const params = {
                method: (newData.id !== null && newData.id !== undefined && newData.id > 0) ? "PUT" : "POST",
                headers: {
                    'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                },
                body: formData
            };
            const response = await fetch(`${baseUrl}QualityControle`, params);

            //const response = await Fetch("QualityControle", (body.id !== null && body.id !== undefined && body.id > 0) ? "PUT" : "POST", body, null, props.toast);
            if (response.ok) {
                props.toast.current.show({ severity: 'success', detail: "Saved Successfully", life: 3000 });
                props.setReload(!props.reload);
                onHide();
            }
            setLoading(false);
        }
    };

    const onSubmit = (data: any) => {
        if (values.trim() === "") {
            props.toast.current.show({ severity: 'error', detail: "Points Discussed is required", life: 3000 });
        } else if ((data.initiator_Entity === null || data.initiator_Entity === undefined) && data.initiator_Type !== "Consultant") {
            props.toast.current.show({ severity: 'error', detail: "Initiator Entity is required", life: 3000 });
        } else if ((data.receiver_Entity === null || data.receiver_Entity === undefined) && data.receiver_Type !== "Consultant") {
            props.toast.current.show({ severity: 'error', detail: "Receiver Entity is required", life: 3000 });
        } else {
            let newData: any = { ...data, points_Discussed: values, initiator_Entity: data.initiator_Entity?.vendor_Company_Name || null, receiver_Entity: data.receiver_Entity?.vendor_Company_Name || null };
            if (newData.initiator_Entity === null) delete newData.initiator_Entity;
            if (newData.receiver_Entity === null) delete newData.receiver_Entity;
            saveToDB(newData);
        }
    };

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "initiator_Type") {
                if (value.initiator_Type != null && value.initiator_Type != undefined && value.initiator_Type.trim() !== "") {
                    setInitiatorEntity(value.initiator_Type);
                    setValue("initiator_Entity", null);
                }
            }
            if (name === "receiver_Type") {
                if (value.receiver_Type != null && value.receiver_Type != undefined && value.receiver_Type.trim() !== "") {
                    setReceiverEntity(value.receiver_Type);
                    setValue("receiver_Entity", null);
                }
            }
        });
        return () => subscription.unsubscribe();

    }, [watch, initiatorEntity, receiverEntity]);

    const audioUploade = (event: FileUploadHandlerParam) => {
        const file = event.files[0];
        if (event.files[0].type === 'audio/mpeg' || event.files[0].type === 'audio/mp3' || event.files[0].type === 'audio/wav' || event.files[0].type === 'audio/aac' || event.files[0].type === 'audio/ogg') {
            if (event.files[0].size > 1024 * 1024 * 10) { // 10 MB
                // console.log(event.files[0].size);
                props.toast.current.show({ severity: 'error', content: "DOCX File should be less than 2 MB." });
                event.options.clear();
            } else {
                setAudioFile(file);
                event.options.clear();
                props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Audio Selecetd", life: 3000 });
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A DOCX File." });
            event.options.clear();
        }
        // setAudioFile(file);
    };

    useEffect(() => {
        if (props.open) {
            loadCompany();
            if (props.singleData?.id) {
                console.log(props.singleData);
                if (props.singleData.initiator_Type === "Prime Vendor") {
                    completeMethodEntityClient({ query: props?.singleData?.initiator_Entity || "" });
                } else if (props.singleData.initiator_Type === "Sub Vendor") {
                    completeMethodEntitySubvendor({ query: props?.singleData?.initiator_Entity || "" });
                };
                if (props.singleData.receiver_Type === "Prime Vendor") {
                    completeMethodEntityClient({ query: props?.singleData?.initiator_Entity || "" });
                } else if (props.singleData.receiver_Type === "Sub Vendor") {
                    completeMethodEntitySubvendor({ query: props?.singleData?.initiator_Entity || "" });
                };

                setInitiatorEntity(props.singleData.initiator_Type || "");
                setReceiverEntity(props.singleData.receiver_Type || "");

                setValues(props.singleData.points_Discussed || "");

                let newData = {
                    call_Type: props.singleData.call_Type,
                    initiator_Type: props.singleData.initiator_Type,
                    point_Of_Contact: props.singleData.point_Of_Contact,
                    receiver_Type: props.singleData.receiver_Type,
                    receiver_Name: props.singleData.receiver_Name,
                    subject: props.singleData.subject,
                    call_Duration: props.singleData.call_Duration,
                    confidence_Level: props.singleData.confidence_Level,
                    voice_Pitch: props.singleData.voice_Pitch,
                    call_Quality: props.singleData.call_Quality,
                    initiator_Entity: props.singleData.initiator_Entity,
                    receiver_Entity: props.singleData.receiver_Entity
                };
                reset(newData);
            }
        }
    }, [props.open])

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown required column={3} label="Call Type:" control={control} name="call_Type" options={[{ name: "Incoming" }, { name: "Outgoing" }]} optionLabel="name" optionValue="name" placeholder="Select Call Type" error={errors.call_Type?.message} />
                <JVDropdown required column={3} label="Initiator Type:" control={control} name="initiator_Type" options={[{ name: "Prime Vendor" }, { name: "Sub Vendor" }, { name: "Consultant" }, { name: "InHouse User" }]} optionLabel="name" optionValue="name" placeholder="Select Initiator Type" error={errors.initiator_Type?.message} />
                {initiatorEntity === "Prime Vendor" && <JVDropdownInput required column={3} label="Initiator Entity" completeMethod={completeMethodEntityClient} control={control} name="initiator_Entity" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search  Client/Company" />}
                {initiatorEntity === "Sub Vendor" && <JVDropdownInput required column={3} label="Initiator Entity" completeMethod={completeMethodEntitySubvendor} control={control} name="initiator_Entity" options={subvendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search  Subvendor" />}
                {initiatorEntity === "InHouse User" && <JVDropdown column={3} label="Initiator Entity (Inhouse):" control={control} name="initiator_Entity" options={company} optionLabel="company_Name" optionValue="company_Name" placeholder="Select Company Name" />}
                <JVInput required column={3} label="Point Of Contact" control={control} name="point_Of_Contact" error={errors.point_Of_Contact?.message} />
                <JVDropdown required column={3} label="Receiver Type:" control={control} name="receiver_Type" options={[{ name: "Prime Vendor" }, { name: "Sub Vendor" }, { name: "Consultant" }, { name: "InHouse User" }]} optionLabel="name" optionValue="name" placeholder="Select Initiator Type" error={errors.initiator_Type?.message} />
                {receiverEntity === "Prime Vendor" && <JVDropdownInput required column={3} label="Receiver Entity" completeMethod={completeMethodEntityClient} control={control} name="receiver_Entity" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" />}
                {receiverEntity === "Sub Vendor" && <JVDropdownInput required column={3} label="Receiver Entity" completeMethod={completeMethodEntitySubvendor} control={control} name="receiver_Entity" options={subvendorCompanies} optionLabel="vendor_Company_Name" placeholder="Search Subvendor" />}
                {receiverEntity === "InHouse User" && <JVDropdown column={3} label="Receiver Entity (Inhouse):" control={control} name="receiver_Entity" options={company} optionLabel="company_Name" optionValue="company_Name" placeholder="Select Company Name" />}
                <JVInput required column={3} label="Receiver Name:" control={control} name="receiver_Name" error={errors.receiver_Name?.message} />
                <JVInput required column={3} label="Subject:" control={control} name="subject" error={errors.subject?.message} />
                <JVInput required column={3} type="number" label="Call Duration: (in minutes)" control={control} name="call_Duration" error={errors.call_Duration?.message} />
                <JVDropdown required column={3} label="Confidence Level:" control={control} name="confidence_Level" options={confidence_Level} optionLabel="name" optionValue="name" placeholder="Select Confidence Level" error={errors.confidence_Level?.message} />
                <JVDropdown required column={3} label="Voice & Pitch:" control={control} name="voice_Pitch" options={voice_Pitch} optionLabel="name" optionValue="name" placeholder="Select Voice & Pitch" error={errors.voice_Pitch?.message} />
                <div className="field col-12 md:col-12">
                    <label>Points Discussed :<span style={{ color: 'red' }}>*</span></label>
                    <InputTextarea value={values} onChange={(e) => setValues(e.target.value)} rows={7} cols={30} />
                </div>
                <JVDropdown required column={3} label="Call Quality:" control={control} name="call_Quality" options={call_Quality} optionLabel="name" optionValue="name" placeholder="Select Call Quality" error={errors.call_Quality?.message} />
                <div className="field col-12 md:col-4">
                    <label>Call Recording:</label>
                    <FileUpload chooseLabel="Choose File" mode="basic" name="resume" accept=".mp3" auto customUpload uploadHandler={audioUploade} />
                </div>






                <div className="flex m-auto" style={{ width: "98%" }}>
                </div>
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" loading={loading} disabled={loading}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}